import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base";
import { getESGReqHeader } from "./tool-service";

export const getBoudaryDeviceList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1040501"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1040501")}`, method: "post", data: ReqBody });
};

export const F1040502Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1040502"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1040502", true)}`, method: "post", data: ReqBody });
};

export const createBoudaryDevice = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1040502"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1040502")}`, method: "post", data: ReqBody });
};

export const F1040503Before = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1040503"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1040503", true)}`, method: "post", data: ReqBody });
};

export const updateBoudaryDevice = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1040503"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1040503")}`, method: "post", data: ReqBody });
};

export const getBoudaryDeviceDropDownList = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1040504"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1040504")}`, method: "post", data: ReqBody });
};